import React from 'react';
import signupleft from '../../images/signupleft.webp';

export default function AuthLayout({ children, imageSrc }) {
  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      {/* Left Side - Image */}
      <div className="hidden lg:flex items-center justify-center bg-muted p-8">
        <div className="max-w-md w-full">
          <img 
            src={imageSrc || signupleft} 
            alt="RxHacker Pro" 
            className="w-full h-auto object-contain"
          />
        </div>
      </div>

      {/* Right Side - Form */}
      <div className="flex items-center justify-center p-4 sm:p-8">
        <div className="w-full max-w-md">
          {children}
        </div>
      </div>
    </div>
  );
}
